import React, { useEffect } from 'react'
import Box from "@mui/material/Box";
import Header from "../../../common/header/Header";
import Breadcrumb from "../../../common/header/Breadcrumb";
import AgreementsListView from '../../../components/AgreementsDetails/AgreementsListView';

const AgreementsList = () => {
   useEffect(() => {
            window.scrollTo(0, 0);
        }, []);
  return (
    <>    
      <Box sx={{ flexGrow: 1 }} className="page-background">
       <Header/>
       <Breadcrumb/>
         <AgreementsListView />
      </Box>
    </>
  )
}

export default AgreementsList